"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignmentFileRoutes = void 0;
var AssignmentFileRoutes;
(function (AssignmentFileRoutes) {
    AssignmentFileRoutes["BasePrefix"] = "assignment-files";
    AssignmentFileRoutes["ById"] = ":assignmentFileId";
    AssignmentFileRoutes["AllByAssignmentId"] = "all/:assignmentId";
})(AssignmentFileRoutes = exports.AssignmentFileRoutes || (exports.AssignmentFileRoutes = {}));
